<template>
  <!-- 전역 로딩 오버레이 ( 관리자 / 사용자 공용 ) -->
  <div
    v-if="isLoading"
    class="loading-overlay"
    :class="{ 'user-theme': !isAdminPage }"
    role="status"
    aria-live="polite"
    aria-label="데이터를 불러오는 중입니다"
  >
    <div class="loading-panel">
      <span class="loading-ring" aria-hidden="true"></span>
      <p class="loading-text">데이터를 불러오는 중입니다</p>
    </div>
  </div>
  <div v-if="isAdminPage" v-cloak class="admin-wrap">
    <AdminHeader />
    <AdminMenu />
    <main class="main-wrap">
      <div
        :class="{
          'content-wrap': true,
          main: this.$route.path === this.$filters.ctxPath('/adm/main.page'),
        }"
        :style="{ height: menuUse === 'Y' ? 'calc(100% - 152px)' : '100%' }"
      >
        <router-view />
      </div>
      <MenuSatisfaction
        v-if="!$route.path.includes('/insert.page')"
        @menuChecck="menuYnCheck"
      />
    </main>
  </div>
  <div v-else v-cloak class="user-wrap relative">
    <component
      :is="headerComponent"
      v-if="showHeader"
      :key="`header-${themeVersion}`"
    />
    <main
      class="main-wrap"
      :style="{
        height: ['/cmslogin.page'].includes($route.path) ? '100%' : '',
      }"
      :class="{ 'apply-padding': applyPadding }"
    >
      <Breadcrumb
        v-if="
          $route.path !== '/' &&
          $route.path !== this.$filters.ctxPath('/adm/main.page') &&
          $route.path !== this.$filters.ctxPath('/main.page')
        "
      />
      <router-view />
      <MenuSatisfaction v-if="!$route.path.includes('/insert.page')" />
    </main>
    <component
      :is="footerComponent"
      v-if="showFooter"
      :key="`footer-${themeVersion}`"
    />
  </div>
</template>
<script>
import { defineAsyncComponent } from "vue";
import AdminHeader from "../layout/AdminHeader.vue";
import AdminMenu from "../layout/AdminMenu.vue";
import Breadcrumb from "../component/Breadcrumb/Breadcrumb.vue";
import MenuSatisfaction from "../layout/menuSatisfaction.vue";
import { getThemeInfo, checkAndReloadTheme, setThemeCssEnabled } from "../index.js";
import { loadingState } from "../../resources/js/loading.js";

export default {
  data: () => {
    return {
      otherWindow: false,
      path: "",
      menuUse: "N",
      headerComponent: null,
      footerComponent: null,
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    // 전역 로딩 오버레이 노출 여부
    isLoading() {
      return loadingState.visible;
    },
    isAdminPage() {
      return (
        this.$route &&
        this.$route.path.startsWith(this.$filters.ctxPath("/adm"))
      );
    },
    themeInfo() {
      return getThemeInfo();
    },
    themeName() {
      return this.themeInfo?.themeName || "default";
    },
    mainTheme() {
      return this.themeInfo?.mainTheme;
    },
    defaultTheme() {
      return this.themeInfo?.defaultTheme;
    },
    themeVersion() {
      return this.mainTheme?.mdfcnDt || this.mainTheme?.regDt || "default";
    },
    showHeader() {
      return (
        // this.path !== this.$filters.ctxPath("/login.page") &&
        this.path !== this.$filters.ctxPath("/cmslogin.page") &&
        !this.$route.path.includes("/popup.page") &&
        // !this.$route.path.includes("/signUp.page") &&
        // !this.$route.path.includes("/term.page") &&
        // !this.$route.path.includes("/resetPswd.page") &&
        !this.$route.path.includes("/notFound.page") &&
        !this.$route.path.includes("/accessDenied.page") &&
        !this.$route.path.includes("/ssoCheck.page")
      );
    },
    showFooter() {
      return ![
        "/cmslogin.page",
        // "/login.page",
        // "/signUp.page",
        // "/term.page",
        // "/resetPswd.page",
        "/notFound.page",
        "/accessDenied.page",
      ].includes(this.$route.path);
    },

    // css 반응형 작업을 위한 변수
    applyPadding() {
      const path = this.$route.path;

      const isAdminPage = path.startsWith(this.$filters.ctxPath("/adm"));

      const isMainPage =
        path === this.$filters.ctxPath("/") ||
        path === this.$filters.ctxPath("/main.page");

      return !isAdminPage && !isMainPage && this.windowWidth <= 1600;
    },
  },
  methods: {
    menuYnCheck(yn) {
      this.menuUse = yn;
    },
    getLayoutThemeName(fileName) {
      // 메인 테마 우선
      if (this.mainTheme?.themaFiles) {
        const hasInMain = this.mainTheme.themaFiles.some(
          (f) => f.themaCl === "layout" && f.fileNm === fileName,
        );
        if (hasInMain) {
          return this.mainTheme.themaNmEng;
        }
      }

      // 기본 테마
      if (this.defaultTheme?.themaFiles) {
        const hasInDefault = this.defaultTheme.themaFiles.some(
          (f) => f.themaCl === "layout" && f.fileNm === fileName,
        );
        if (hasInDefault) {
          return this.defaultTheme.themaNmEng;
        }
      }

      return "default";
    },
    loadThemeComponents() {
      const headerTheme = this.getLayoutThemeName("UserHeader.vue");
      this.headerComponent = defineAsyncComponent(() =>
        import(`./user/themes/${headerTheme}/layout/UserHeader.vue`).catch(
          () => import(`./user/themes/default/layout/UserHeader.vue`),
        ),
      );

      const footerTheme = this.getLayoutThemeName("Footer.vue");
      this.footerComponent = defineAsyncComponent(() =>
        import(`./user/themes/${footerTheme}/layout/Footer.vue`).catch(
          () => import(`./user/themes/default/layout/Footer.vue`),
        ),
      );
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
    // rem 기반 반응형 폰트 스케일(html font-size)을 gbAX 사용자 포털 페이지에만
    // 적용하기 위한 스코프 클래스. rem은 <html>의 font-size만 참조하므로
    // 특정 wrapper로 감싸는 걸로는 범위를 못 좁히고, 이렇게 <html>에 조건부
    // 클래스를 달아야 관리자 페이지(별도 rem 체계 사용)를 건드리지 않는다.
    updateHtmlScaleClass() {
      const shouldScale = !this.isAdminPage && this.themeName === "gbAX";
      document.documentElement.classList.toggle(
        "gbax-user-scale",
        shouldScale,
      );
    },
    // 관리자페이지는 문서 스크롤 막고(.main-wrap에서 스크롤 대체), 사용자페이지는 문서 스크롤 사용
    updateHtmlOverflow() {
      document.documentElement.style.overflowY = this.isAdminPage
        ? "hidden"
        : "auto";
    },
    // 사용자 테마 CSS 는 사용자페이지에서만 켠다 (관리자는 자체 SCSS 만 사용)
    updateThemeCss() {
      setThemeCssEnabled(!this.isAdminPage);
    },
  },
  watch: {
    $route(to, from) {
      this.path = to.path;
      if (
        this.path.includes("/insert.page") ||
        this.path.includes("/view.page")
      ) {
        this.menuUse = "N";
      }

      // 라우터 이동 시 테마 버전 체크 (변경되면 자동 새로고침)
      checkAndReloadTheme();
      this.updateHtmlScaleClass();
      this.updateHtmlOverflow();
      this.updateThemeCss();
    },
    themeName: {
      immediate: true,
      handler() {
        this.loadThemeComponents();
        this.updateHtmlScaleClass();
      },
    },
  },
  mounted() {
    this.loadThemeComponents();
    this.updateHtmlScaleClass();
    this.updateHtmlOverflow();
    this.updateThemeCss();
    window.addEventListener("resize", this.handleResize);
  },
  components: {
    AdminHeader: AdminHeader,
    AdminMenu: AdminMenu,
    Breadcrumb: Breadcrumb,
    MenuSatisfaction: MenuSatisfaction,
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.handleResize);
  },
};
</script>
<style scoped>
[v-cloak] {
  display: none;
}
</style>
